import * as moment from "moment";
var getRegisterdDevicMapper = function (AllRegisteredDevices) {
    var result = {
        type: "",
        dvLst: [],
    };
    if (AllRegisteredDevices) {
        var list = AllRegisteredDevices.data.dvLst.map(function (item) {
            return {
                appId: item.appId,
                browserName: item.bwsNm,
                clvrTpId: item.clvrTpId,
                deviceName: item.devNm,
                lastLogin: moment(item.llt).format("DD-MM-YYYY"),
                platform: item.pltf,
                regt: moment(item.regt).format("DD-MM-YYYY"),
            };
        });
        result.dvLst = list;
    }
    return result;
};
export default getRegisterdDevicMapper;
